import { ref } from "vue"
import { previewDataEntries } from "../utils/content_preview_format"

export function useContentPreview(labels = {}) {
  const isLoading = ref(false)
  const errorMessage = ref("")
  const content = ref(null)
  const editUrl = ref("#")
  const viewUrl = ref("#")

  const label = (key, fallback) => labels[key] || fallback

  async function loadContent(id, url) {
    isLoading.value = true
    errorMessage.value = ""
    content.value = null
    editUrl.value = `/admin/contents/${id}/edit`
    viewUrl.value = url

    try {
      const response = await fetch(`/admin/contents/${id}.json`, {
        headers: { Accept: "application/json" },
      })

      if (!response.ok) throw new Error("Failed to load content")

      const data = await response.json()
      content.value = {
        ...data,
        dataEntries: previewDataEntries(data.data),
        description: data.data?.description || data.description || "",
      }
    } catch (error) {
      console.error("Preview error:", error)
      errorMessage.value = label("error", "Failed to load")
    } finally {
      isLoading.value = false
    }
  }

  function handlePreviewEvent(event) {
    const { id, url } = event.detail
    loadContent(id, url)
  }

  return {
    isLoading,
    errorMessage,
    content,
    editUrl,
    viewUrl,
    label,
    loadContent,
    handlePreviewEvent,
  }
}
